define([
	'view/MainView'
], function (
	MainView
) {
	'use strict';

	var _availableLocalization = [ 'de', 'en'],
		_defaultLocale = 'en',
		_locale = null,
		_mainView = null;


	// public methods

	function setMainView(mainView) {
		if (mainView instanceof MainView) {
			_mainView = mainView;
		}
	}

	function setLocale(locale) {
		if (locale !== _locale && _availableLocalization.indexOf(locale) !== -1) {
			try {
				localStorage.setItem('skIdS_locale', locale);

				if (_mainView !== null) {
					_mainView.hide(true, function () {
						_mainView.get().remove();

						window.location.reload(false);
					})
				} else {
					window.location.reload();
				}
			} catch (exception) {
				// ignore
			}
		}
	}

	function getDefaultLocale() {
		return _defaultLocale;
	}

	function getAvailableLocalizations() {
		return _availableLocalization;
	}

	function getLocale() {
		if (_locale === null) {
			try {
				_locale = localStorage.getItem('skIdS_locale');
				
				if (_locale !== null && _availableLocalization.indexOf(_locale) === -1) {
					localStorage.removeItem('skIdS_locale');

					window.location.reload();

					return;
				}
			} catch (exception) {
				// ignore
			}

			if (_locale === null) {
				_locale = (navigator.languages && navigator.languages[0]) ||
								navigator.language || navigator.userLanguage;
			}
		}

		window._i18n = {};
		window._i18n.locale = _locale;
		return _locale;
	}

	function getShortLocale() {
		var locale = getLocale();

		if (locale.indexOf('-') !== -1) {
			locale = locale.substring(0, locale.indexOf('-'));
		}

		window._i18n = {};
		window._i18n.locale = _locale;
		return locale.toLowerCase();
	}

	//

	return {
		setMainView : setMainView,
		setLocale : setLocale,
		getDefaultLocale : getDefaultLocale,
		getAvailableLocalizations : getAvailableLocalizations,
		getLocale : getLocale,
		getShortLocale : getShortLocale
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/util/LocalizationUtil.js
// module id = 28
// module chunks = 6